import Header from "../header";
import Footer from "../footer";
import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { sendRegistrationOtp,verifyRegisterOtp} from "apiCalls/applyClaimService";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useLanguage } from "context/LanguageContext";

function NewRegister() {

    const navigate = useNavigate();
    const { t } = useLanguage();
    const [formData, setFormData] = useState({
        applicantName: "",
        email: "",
        mobileNumber: "",
    });
    const [otpSend,setOtpSend] = useState(false)
    const [resendTimer, setResendTimer] = useState(0);
    const [mobileError, setMobileError] = useState("");

    useEffect(() => {
        if (resendTimer <= 0) return;
        const id = setTimeout(() => setResendTimer((t) => t - 1), 1000);
        return () => clearTimeout(id);
    }, [resendTimer]);
    const [otpError,setOtpError] = useState("")
    const [otp, setOtp] = useState(["", "", "", "", "", ""]);
    const [errors,setErrors] = useState({})
    const [loading,setLoading] = useState(false)
    const [verifyLoading,setVerifyLoading] = useState(false)
    const otpRefs = useRef([]);
    const [otpPrefix, setOtpPrefix] = useState("");

    const validate = () => {
        const newErrors = {};
        if (!formData.applicantName.trim())
            newErrors.applicantName = "Full name is required.";
        if (!formData.email.trim())
            newErrors.email = "Email is required.";
        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email))
            newErrors.email = "Enter a valid email address.";
        if (!formData.mobileNumber.trim())
            newErrors.mobileNumber = "Mobile number is required.";
        else if (!/^[6-9]\d{9}$/.test(formData.mobileNumber))
            newErrors.mobileNumber = "Enter a valid 10-digit mobile number.";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "mobileNumber") {
            const digits = value.replace(/\D/g, "");
            setFormData((prev) => ({ ...prev, mobileNumber: digits }));
            setOtpSend(false);
            setOtp(["", "", "", "", "", ""]);
            setMobileError("");
        } else {
            setFormData((prev) => ({ ...prev, [name]: value }));
        }
    };

    const handleSendOtp = async () => {
        if (!validate()) return;
        setMobileError("");
        setLoading(true);
        try {
           const res = await sendRegistrationOtp(formData.applicantName, formData.mobileNumber);
           if (res.status !== "success") {
               setMobileError(res.message || "Failed to send OTP. Please try again.")
               return
           }
           setOtpSend(true);
           setResendTimer(30);
           if (res.otp) {
                setOtpPrefix(res.otp_prefix || "");
                toast.success(`OTP: ${res.otp}`, { autoClose: false });
            }
        } catch (err) {
            setMobileError(err?.message || "Failed to send OTP. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const handleVerifyRegister = async () => {
        setOtpError("");
        const otpValue = otp.join("");
        if (otpValue.length !== 6) {
            setOtpError("Please enter the complete 6-digit OTP.");
            return;
        }
        setVerifyLoading(true);
        try {
            const res = await verifyRegisterOtp(formData.applicantName, formData.mobileNumber, otpValue)
            if (res.status !== "success") {
                setOtpError(res.message || "OTP verification failed. Please try again.")
                return
            }
            sessionStorage.setItem("jwt", res.token)
            sessionStorage.setItem("userName", res.data.name)
            navigate("/userDashboard")
        } catch (err) {
            setOtpError(err?.message || "OTP verification failed. Please try again.");
        } finally {
            setVerifyLoading(false);
        }
    }
    
    const handleReSendOtp = async () => {
        setResendTimer(30);
        setOtp(["", "", "", "", "", ""]);
        setOtpError("");
        otpRefs.current.forEach((ref) => { if (ref) ref.value = ""; });
        if (otpRefs.current[0]) otpRefs.current[0].focus();
        setLoading(true);
        try {
            const res = await sendRegistrationOtp(formData.applicantName, formData.mobileNumber);
            if (res.otp) {
                toast.dismiss();
                setOtpPrefix(res.otp_prefix || "");
                toast.success(`OTP: ${res.otp}`, { autoClose: false });
            }
        } catch (err) {
            setMobileError(err?.message || "Failed to resend OTP. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const handleOtpChange = (value, index) => {
        if (!/^\d*$/.test(value)) return;
        const updated = [...otp];
        updated[index] = value;
        setOtp(updated);
        if (value && index < 5) {
            otpRefs.current[index + 1].focus();
        }
    };

    const handleOtpKeyDown = (e, index) => {
        if (e.key === "Backspace" && !otp[index] && index > 0) {
            otpRefs.current[index - 1].focus();
        }
    };

return(
    <>
    <Header />

    {/* ==== Scroll up and prograss start ==== */}
    <div id="scrollUp">
        <svg className="arrowup" viewBox="0 0 24 24" width="18" height="18">
            <path d="M13 7.828V20h-2V7.828l-5.364 5.364-1.414-1.414L12 4l7.778 7.778-1.414 1.414L13 7.828z" fill="#fff" />
        </svg>
        <svg className="scrollprogress" width="40" height="40">
            <circle className="progress-circle" cx="20" cy="20" r="18" strokeWidth="2" fill="none" stroke="#fff" strokeDasharray="113.1" strokeDashoffset="113.1" />
        </svg>
    </div>
    {/* ==== Scroll up and prograss Ends ==== */}

    {/* ==== Account Creation Page Banner Section Start ==== */}
    <section className="rs-page-banner rs-faq-page-banner pt-30 pb-30 mt-140">
        <div className="container">
            <div className="row">
                <div className="col-lg-7">
                    <div className="rs-page-banner__content">
                        <h1 className="title">{t.newRegistration}</h1>
                        <p>{t.newRegSubtitle}</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
    {/* ==== Account Creation Page Banner Section Ends ==== */}

    {/* ==== Page Section Start ==== */}
    <section className="rs-faq-page pt-50 pb-120">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-lg-5">
                    <div className="card logindiv">
                        <div className="card-body p-5">

                            <div className="mb-2">
                                <label className="form-label">{t.applicantFullName}</label>
                                <input type="text" name="applicantName" className={`form-control ${errors.applicantName ? "is-invalid" : ""}`} placeholder="" value={formData.applicantName}
                                 onChange={handleChange}/>
                                {errors.applicantName && <div className="invalid-feedback">{errors.applicantName}</div>}
                            </div>

                            <div className="mb-2">
                                <label className="form-label">{t.emailAddress}</label>
                                <input type="text" name="email" className={`form-control ${errors.email ? "is-invalid" : ""}`} placeholder="" value={formData.email}
                                 onChange={handleChange}/>
                                {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                            </div>

                            <div className="mb-3">
                                <label className="form-label">{t.mobileNumber}</label>
                                <input type="tel" name="mobileNumber" maxLength={10} className={`form-control ${errors.mobileNumber ? "is-invalid" : ""}`} placeholder="" value ={formData.mobileNumber}
                                 onChange={handleChange}/>
                                {errors.mobileNumber && <div className="invalid-feedback">{errors.mobileNumber}</div>}
                            </div>

                            <div className="d-grid mb-2">
                                <button className="btn btn-primary" onClick={handleSendOtp} disabled={loading || otpSend}>
                                    {loading ? t.sending : t.sendOtp}
                                </button>
                            </div>
                            {mobileError && <div className="text-danger small mb-3">{mobileError}</div>}

                            {/* OTP Section */}
                            <div id="otpSection" className={!otpSend ? "opacity-50" : ""}>
                                <label className="form-label">{t.enter6DigitOtp}</label>
                                <div className="d-flex align-items-center gap-2 mb-3">
                                    {/* OTP Prefix */}
                                    {otpPrefix && (
                                        <div className="px-3 py-2 border rounded bg-light fw-bold" style={{ minWidth: "70px", textAlign: "center" }}>
                                    {otpPrefix}
                                    </div>
                                    )}
                                <div className="d-flex justify-content-between gap-3 flex-grow-1">
                                    {otp.map((digit, index) => (
                                        <input
                                            key={index}
                                            ref={(el) => (otpRefs.current[index] = el)}
                                            type="text"
                                            maxLength={1}
                                            className="form-control otp-input"
                                            value={digit}
                                            disabled={!otpSend}
                                            onChange={(e) => handleOtpChange(e.target.value, index)}
                                            onKeyDown={(e) => handleOtpKeyDown(e, index)}
                                        />
                                    ))}
                                    </div>
                                </div>
                                {otpError && <div className="text-danger small mb-2">{otpError}</div>}
                                <div className="d-grid">
                                    <button className="btn btn-success" id="verifyBtn" disabled={!otpSend || verifyLoading || otp.join("").length !== 6} onClick={handleVerifyRegister}>
                                        {verifyLoading ? t.verifying : t.verifyRegister}
                                    </button>
                                </div>
                                <p className="small">
                                    {t.dontReceiveCode}{" "}
                                    <button className="btn btn-link btn-sm p-0" style={{ color: "#25826a", textDecoration: "none" }} onClick={handleReSendOtp} disabled={!otpSend || resendTimer > 0}>{t.resend}</button>
                                    {resendTimer > 0 && <span className="small text-muted ms-1">({resendTimer}s)</span>}
                                </p>
                            </div>
                            <div className="text-center mt-3">
                                {t.alreadyHaveAccount}{" "}
                                <span style={{ color: "#25826a", cursor: "pointer", textDecoration: "underline" }} onClick={() => navigate("/login")}>{t.loginHere}</span>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    {/* ==== Page Section Ends ==== */}

    <Footer />
    <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick={false}
        closeButton={true}
        rtl={false}
        pauseOnFocusLoss
        draggable={false}
        pauseOnHover
        limit={1}
        style={{ zIndex: 9999 }}
    />
    </>
)
}

export default NewRegister
